
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import TaxiCard from "./TaxiCard";
import Timer from "../core/components/Timer";
/* START-USER-IMPORTS */
import { CharacterNameValues } from "../Character";
/* END-USER-IMPORTS */

export default class PickupUI extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // scoreBonus
    const scoreBonus = scene.add.container(0, -185);
    this.add(scoreBonus);

    // scoreIcon
    const scoreIcon = scene.add.image(-70, 6, "common", "icon-note-pile.png");
    scoreBonus.add(scoreIcon);

    // scoreBonusCopy
    const scoreBonusCopy = scene.add.text(18, 2, "", {});
    scoreBonusCopy.setOrigin(0, 0.5);
    scoreBonusCopy.text = "+15";
    scoreBonusCopy.setStyle({ "baselineY":1.2,"fixedWidth":120,"fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "45px" });
    scoreBonus.add(scoreBonusCopy);

    // messageContainer
    const messageContainer = scene.add.container(0, 227);
    this.add(messageContainer);

    // taxiCard
    const taxiCard = new TaxiCard(scene, 0, -49);
    taxiCard.scaleX = 0.6;
    taxiCard.scaleY = 0.6;
    taxiCard.angle = 0;
    messageContainer.add(taxiCard);

    // copy
    const copy = scene.add.text(0, 40, "", {});
    copy.setOrigin(0.5, 0.5);
    copy.text = "PICKUP!";
    copy.setStyle({ "align": "center", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "50px" });
    messageContainer.add(copy);

    // copy (components)
    new Timer(copy);

    this.scoreBonus = scoreBonus;
    this.scoreBonusCopy = scoreBonusCopy;
    this.messageContainer = messageContainer;
    this.taxiCard = taxiCard;
    this.copy = copy;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private scoreBonus: Phaser.GameObjects.Container;
  private scoreBonusCopy: Phaser.GameObjects.Text;
  private messageContainer: Phaser.GameObjects.Container;
  private taxiCard: TaxiCard;
  private copy: Phaser.GameObjects.Text;

  /* START-USER-CODE */

  private scoreBonusY:number=0;
  protected awake(){
    this.scoreBonusY = this.scoreBonus.y;
    this.hideMessage();
    this.hideScoreBonus();
  }

  public showMessage(msg:string, bonus:number, card:CharacterNameValues){

    this.taxiCard.changeOwner(card);
    this.copy.text = msg;
    this.messageContainer.alpha = 1;
    this.scene.add.tween({
      targets: [this.messageContainer],
      scale:1,
      duration: 500,
      ease: Phaser.Math.Easing.Bounce.Out,
      delay: 100
    });

    this.scene.add.tween({
      targets: [this.messageContainer],
      scale:0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: 1200,
      onComplete: () => {
        this.hideMessage();
      },
    });

    if(bonus>0){
      this.scoreBonus.alpha = 1;
      this.scoreBonus.y = this.scoreBonusY;
      this.scoreBonusCopy.text = "+"+bonus;
      this.scene.add.tween({
        targets: [this.scoreBonus],
        scale:1,
        duration: 500,
        ease: Phaser.Math.Easing.Bounce.Out,
        delay: 200
      });

      this.scene.add.tween({
        targets: [this.scoreBonus],
        alpha:0,
        y:this.scoreBonusY-100,
        duration: 1000,
        ease: Phaser.Math.Easing.Cubic.In,
        delay: 700,
        onComplete: () => {
          this.hideScoreBonus();
        },
      });
    }
  }

  private hideScoreBonus(){
    this.scoreBonus.alpha = 0;
    this.scoreBonus.scale=0;
  }

  private hideMessage(){
    this.messageContainer.alpha = 0;
    this.messageContainer.scale=0;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
